var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoserCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 4.5,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#810101"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 4.5,
    width: 20,
    height: 20,
    rx: 10,
    stroke: "#DF0000"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4127_1990)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7297 14.5L17.9492 12.2806C18.0169 12.2128 18.0169 12.1025 17.9492 12.0347L16.9653 11.0508C16.8975 10.9831 16.7872 10.9831 16.7194 11.0508L14.5 13.2703L12.2806 11.0508C12.2128 10.9831 12.1025 10.9831 12.0347 11.0508L11.0508 12.0347C10.9831 12.1025 10.9831 12.2128 11.0508 12.2806L13.2703 14.5L11.0508 16.7194C10.9831 16.7872 10.9831 16.8975 11.0508 16.9653L12.0347 17.9492C12.1025 18.0169 12.2128 18.0169 12.2806 17.9492L14.5 15.7297L16.7194 17.9492C16.7872 18.0169 16.8975 18.0169 16.9653 17.9492L17.9492 16.9653C18.0169 16.8975 18.0169 16.7872 17.9492 16.7194L15.7297 14.5Z",
    fill: "#FF5656"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4127_1990",
    x: 0,
    y: 0,
    width: 29,
    height: 29,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.87451 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4127_1990"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4127_1990",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoserCrossIcon);
export default __webpack_public_path__ + "static/media/loserCrossIcon.ec1d4a9134af4318ea1e18778a926b28.svg";
export { ForwardRef as ReactComponent };